<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2">Membership</h1>

                <v-overlay :absolute="true" :value="overlay" z-index="99" opacity="0.56">
                    <v-card>
                        <v-card-text v-html="overlayText"></v-card-text>
                        <v-card-actions>
                            <v-btn medium block dark :color="overlayColor" @click="overlay = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <div class="mt-4" v-if="membReq == false" v-cloak>
                    <v-alert outlined transition="scale-transition" type="error">{{ membershipErrors.errors }}</v-alert>
                </div>

                <div v-if="memberRenewal && membReq == true" v-cloak>
                    <v-stepper v-model="memStep" vertical>
                        <v-stepper-step editable :complete="memStep > 1" step="1">
                            Membership Review<br><span class="py-1 font-weight-bold">{{sport.text | capitalize}}</span>
                        </v-stepper-step>

                        <v-stepper-content step="1">
                            <v-card color="grey lighten-5" class="mb-5 elevetation-6">
                                <p class="pa-2 pb-0">
                                    By registering with {{ appNameUrls.assoc_name }}, you agree to our Terms and that you have read the {{sport.text | capitalize}} Network Terms & Conditions,
                                    {{sport.text | capitalize}} Australian National Integrity Framework and {{ appNameUrls.assoc_name }} policies & procedures.
                                    <a href="/about/policy-procedures/" target="_blank">Click here</a>
                                    to view.
                                </p>
                                <!-- <p class="pa-2 pt-0">
                                    Please select your registration term carefully. Once purchased, the selected registration period (6-month or 12-month) cannot be extended by paying a pro-rata difference after expiry. If you wish to continue beyond the expiry date, a new registration must be purchased at the applicable rate at that time.
                                </p> -->
                                <div class="Ftable">
                                    <div class="Ftable__row Ftable__header">
                                        <div class="Ftable__item cols-2 text-left">Membership</div>
                                        <div class="Ftable__item text-right"></div>
                                        <div class="Ftable__item text-right">Price</div>
                                    </div>
                                    <div class="Ftable__row" v-for="(prd, index) in membershipCart" :key="index">
                                        <div class="Ftable__item cols-2 text-left">
                                            <label><input type="radio" v-model="regopick" :value="index"> <span>{{ prd.p_name }}</span></label>
                                        </div>
                                        <div class="Ftable__item text-right"></div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ prd.p_price | currency }}</span>
                                        </div>
                                    </div>
                                    <div class="Ftable__row Ftable__header">
                                        <div class="Ftable__item cols-2 text-left"></div>
                                        <div class="Ftable__item text-right"></div>
                                        <div class="Ftable__item text-right"></div>
                                    </div>
                                    <div class="Ftable__row">
                                        <div class="Ftable__item cols-2 no-border right-border top-border"></div>
                                        <div class="Ftable__item text-right">
                                            <span><strong>Subtotal</strong></span>
                                        </div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ subTotal | currency("$") }}</span>
                                        </div>
                                    </div>
                                    <div class="Ftable__row">
                                        <div class="Ftable__item cols-2 no-border right-border bottom-border"></div>
                                        <div class="Ftable__item text-right">
                                            <span><strong>Tax</strong></span>
                                        </div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ taxTotal | currency("$") }}</span>
                                        </div>
                                    </div>
                                    <div class="Ftable__row">
                                        <div class="Ftable__item cols-2"></div>
                                        <div class="Ftable__item text-right">
                                            <span>
                                                <strong>Active & Creative Kids / {{ appNameUrls.client }} Voucher </strong>
                                            </span>
                                            <v-btn v-if="couponApplied" small dark color="red" @click="removeVoucher">remove</v-btn>
                                        </div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ discountTotal | currency("$") }}</span>
                                        </div>
                                    </div>
                                    <div class="Ftable__row">
                                        <div class="Ftable__item cols-2 no-border right-border top-border"></div>
                                        <div class="Ftable__item text-right">
                                            <span><strong>Total</strong></span>
                                        </div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ grandTotal | currency("$") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </v-card>

                            <v-btn v-if="!couponApplied" color="primary" @click="memStep = 2">Continue</v-btn>
                            <v-btn v-if="couponApplied" color="primary" @click="memStep = 3">Continue</v-btn>
                        </v-stepper-content>

                        <v-stepper-step
                            editable
                            :rules="[() => !couponErrors.any()]"
                            :complete="memStep > 2 || couponApplied"
                            step="2"
                            :color="(couponApplied || memStep > 2) ? 'success' : 'primary'"
                        >
                            Enter Active & Creative Kids / {{ appNameUrls.client }} Voucher
                            <small>{{ getCouponMessage }}</small>
                        </v-stepper-step>

                        <v-stepper-content step="2">
                            <v-card outlined color="grey lighten-5" class="mb-5 elevetation-6">
                                <v-expansion-panels :value="0">
                                    <v-expansion-panel class="secondary white--text">
                                        <v-expansion-panel-header>Active & Creative Kids / {{ appNameUrls.client }} Voucher</v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-card>
                                                <v-card-text>
                                                    <coupon :grand-total="subTotal" @submitted-voucher="submittedVoucher"></coupon>
                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card>

                            <v-btn color="primary" @click="memStep = 3">Continue</v-btn>
                        </v-stepper-content>

                        <v-stepper-step :rules="[() => !paymentErrors.any()]" :complete="memStep > 3" step="3">
                            Make Online Payment {{ grandTotal | currency }}
                            <small
                                v-if="paymentErrors.any() && !paymentErrors.has('error_response')"
                                class="caption font-weight-bold secondary--text"
                                v-html="getPaymentMessage"
                            ></small>
                            <small
                                v-if="paymentErrors.any() && paymentErrors.has('error_response')"
                                class="caption font-weight-bold secondary--text"
                                v-html="paymentErrors.get('error_response')"
                            ></small>
                        </v-stepper-step>

                        <v-stepper-content step="3">
                            <donation v-if="showCpDonation"></donation>

                            <v-card color="grey lighten-5" class="mb-5 elevetation-6">
                                <v-card-text>
                                    <component :is="ftGateway" v-if="grandTotal > 0" @submitted-pay="submitPay"></component>
                                    <v-alert dense outlined v-if="grandTotal <= 0" type="info">No Payment required. Click button below to complete process.</v-alert>
                                </v-card-text>
                            </v-card>

                            <v-btn :loading="payLoading" :disabled="!validPaymentForm" color="primary" @click="payrego" class="mr-2 text-left"
                                ><v-icon left>local_atm</v-icon>{{ payHtml }}: {{ grandTotal | currency }}</v-btn
                            >
                            <v-btn v-if="grandTotal > 0" @click="clearPay" color="warning" :disabled="payLoading" class="text-left"
                                >clear
                                <v-icon right>clear</v-icon>
                            </v-btn>
                        </v-stepper-content>
                    </v-stepper>
                </div>
                <div v-if="user"></div>
                <div v-if="!memberRenewal">
                    You do not have to renew your <b>{{sport.text | capitalize}}</b> membership before:
                    <span class="font-weight-bold">{{ renewalDate }}</span>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";
import moment from "moment";

import { EventBus } from "@shared/EventBus.js";
import Eway from "@components/gateways/Eway.vue";
import MerchantWarrior from "@components/gateways/MerchantWarrior.vue";
import Coupon from "@components/coupons/Coupon.vue";
import Donation from "@components/donation/Donation.vue";

export default {
    name: "MembershipModule",
    components: {
        eway: Eway,
        merchantWarrior: MerchantWarrior,
        coupon: Coupon,
        donation: Donation,
    },
    data() {
        return {
            memStep: 1,
            regopick: 0,

            membReq: null,
            overlay: false,
            timeout: 500,
            overlayText: "",
            overlayColor: "cyan darken-2",

            // ftGateway: process.env.MIX_FT_GATEWAY,
            ftGateway: gtwPw,
            showCpDonation: showDonation,
            validPaymentForm: true,

            sport: {},
            sports: [],
            all_sports: [],
        };
    },
    computed: {
        donationTotal() {
            return this.$store.getters["donation/donationTotal"];
        },
        discountTotal() {
            return this.$store.getters["coupon/discountTotal"];
        },
        couponApplied() {
            return this.$store.getters["coupon/couponApplied"];
        },
        couponErrors() {
            return this.$store.getters["coupon/couponErrors"];
        },
        couponLoading() {
            return this.$store.getters["coupon/couponStatus"] == "loading";
        },
        getCouponMessage() {
            return this.$store.getters["coupon/couponMessage"];
        },
        membershipErrors() {
            return this.$store.getters["membership/membershipErrors"];
        },
        paymentErrors() {
            return this.$store.getters["membership/paymentErrors"];
        },
        getPaymentMessage() {
            if (this.paymentErrors.any()) {
                if (this.paymentErrors.has("error_response")) {
                    return this.paymentErrors.get("error_response");
                }

                if (this.paymentErrors.has("error_validation")) {
                    return "Membership Data Invalid";
                }

                if (this.paymentErrors.has("error_payment")) {
                    return this.paymentErrors.get("error_payment");
                }

                return "Payment Invalid";
            }

            return "";
        },
        payLoading() {
            return this.$store.getters["membership/paymentStatus"] == "loading";
        },
        payHtml() {
            if (this.grandTotal > 0) {
                return "Pay Membership";
            }

            return "Complete Membership";
        },
        user() {
            let sports = this.$store.getters["user/getSports"];
            if(_.size(sports)){
                this.sports = sports;
            }

            let all_sports = this.$store.getters["user/allSports"];
            if(_.size(all_sports)){
                const _sports_filter = [];

                _.map(all_sports, function(obj){
                    _sports_filter.push({'text' : obj.text.replace('register for ',''), 'value' : obj.value, 'expiry_date': '', 'memb_renewal': true, 'prev_expiry_date': ''});
                });

                if(!_.size(sports)){
                    this.sports = _sports_filter;
                }

                this.all_sports = _sports_filter;
            }

            return this.$store.getters["user/getProfile"];
        },
        renewalDate() {
            return moment(this.msPivotField(this.sport.value), "DD/MM/YYYY", true)
                .subtract(31, "days")
                .format("dddd Do MMMM YYYY");
        },
        memberRenewal() {
            return this.msPivotField(this.sport.value, 'memb_renewal');
        },
        membershipCart() {
            return this.$store.getters["membership/membershipCart"];
        },
        subTotal() {
            return this.membershipCart[this.regopick].p_price;
        },
        taxTotal() {
            return this.subTotal / (taxRate + 1);
        },
        grandTotal() {
            return this.subTotal - this.discountTotal + this.donationTotal;
        },
    },
    watch: {
        sports(n, o) {
            if(n){
                let sport = _.filter(this.all_sports, ['text', this.$route.query.sport.toLowerCase().trim().replace('register for ','')]);
                if(_.size(sport)){
                    let s = _.intersectionBy(this.all_sports, sport, 'value');
                    this.sport = sport[0];
                    // this.msPivotField(sport[0].value, 'memb_renewal');
                }
            }
        },
    },
    methods: {
        msPivotField(sport_id, field = 'expiry_date') {
            let sportObj = _.filter(this.sports, ['value', sport_id]);
            if(sportObj.length < 1){
                sportObj = _.filter(this.all_sports, ['value', sport_id]);
                if(sportObj.length < 1){
                    return false;
                }

                return sportObj[0][field];
            }

            return sportObj[0][field];
        },
        submittedVoucher() {
            this.memStep = 1;
        },
        removeVoucher() {
            this.$store.dispatch("coupon/removeVoucher");
        },
        clearVoucher() {
            this.$store.dispatch("coupon/clearCouponErrors");
        },
        clearPay() {
            EventBus.$emit("clear-pay");
            this.$store.dispatch("membership/clearPaymentErrors");
        },
        payrego: function() {
            if (this.grandTotal > 0) {
                EventBus.$emit("submit-pay");
            } else {
                this.submitPay();
            }
        },
        submitPay: function(payload) {
            this.validPaymentForm = false;

            const cardPayload = payload;
            const couponCart = this.$store.getters["coupon/couponCart"];
            const donationCart = this.$store.getters["donation/donationCart"];

            this.$store
                .dispatch("membership/payRego", {
                    cardPayload: cardPayload,
                    couponCart: couponCart,
                    donationCart: donationCart,
                    pickRego: this.regopick,
                    sport: this.$route.query.sport.toLowerCase().trim().replace('register for ','')
                })
                .then(order_id => {
                    this.overlayText = "Payment was successful.";
                    this.overlay = true;
                    this.overlayColor = "primary";
                    this.membReq = true;

                    this.clearVoucher();

                    setTimeout(() => {
                        this.$store
                            .dispatch("order/orderRequest")
                            .then(() => {
                                this.$router.push({
                                    name: "orderDetail",
                                    params: { order_id: order_id },
                                });
                            })
                            .catch();
                    }, this.timeout / 4);
                })
                .catch(err => {
                    this.validPaymentForm = true;
                    // console.log(err);

                    setTimeout(() => {
                        EventBus.$emit("clear-pay");
                    }, 500);
                });
        },
    },
    created() {
        // this.$store.dispatch('user/userRequest');

        this.$store
            .dispatch("membership/membershipRequest", {sport: this.$route.query.sport.toLowerCase().trim().replace('register for ','')})
            .then(resp => {
                // console.log(resp);
                this.membReq = true;
            })
            .catch(err => {
                // console.log(err.error);
                this.membReq = false;
            });
    },
};
</script>

<style lang="scss" scoped>
[v-cloak] {
    display: none;
}
[v-cloak] > * {
    display: none;
}

.Ftable {
    $light-color: #ffffff;
    $header-color: #f8c689;
    $dark-color: #f2f2f2;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*border: 1px solid $dark-color;*/
    font-size: 1rem;
    padding: 0;
    margin: 0;
    line-height: 1.5;

    .Ftable__row {
        width: 100%;
        display: flex;

        &.Ftable__header {
            font-weight: bold;

            .Ftable__item {
                background: $header-color;
            }
        }

        .Ftable__item {
            flex: 1 1 25%;
            word-break: break-word;
            padding: 0.25em;
            border: 1px solid $light-color;
            background: $dark-color;

            &.cols-2 {
                flex: 1 1 50%;
            }

            &.no-border {
                border: 0px solid $light-color;
            }

            &.right-border {
                border-right: 1px solid $light-color;
            }

            &.top-border {
                border-top: 1px solid $light-color;
            }

            &.bottom-border {
                border-bottom: 1px solid $light-color;
            }
        }
    }
}
</style>
